export const QA_NAME_AI_DRAFT_PANEL_CLOSE_BUTTON = 'ai_draft_close_button'

export const QA_NAME_AI_DRAFT_PANEL_COPY_BUTTON = 'ai_draft_copy_button'

export const QA_NAME_AI_DRAFT_PANEL_REGENERATE_BUTTON =
  'ai_draft_regenerate_button'

export const QA_NAME_AI_DRAFT_PANEL_DISCARD_BUTTON = 'ai_draft_discard_button'

export const QA_NAME_AI_DRAFT_PANEL_INSERT_BELOW_BUTTON =
  'ai_draft_insert_below_button'

export const QA_NAME_AI_DRAFT_PANEL_REPLACE_BUTTON = 'ai_draft_replace_button'

export const QA_NAME_AI_DRAFT_PANEL_APPLY_BUTTON = 'ai_draft_apply_button'
